module.exports = __webpack_public_path__ + "static/NeueEODisplay65Medium-349a64be66c23f97b08b9b5b78f22432.woff2";